<template>
  <div class="clearfix">
    <a-upload
      :action="uploadImgUrl"
      list-type="picture-card"
      :file-list="fileList"
      :multiple="allowMultiple"
      :headers="headers"
      :before-upload="beforeUpload"
      :accept="'image/*,video/mp4'"
      @preview="handlePreview"
      @change="handleChange"
    >
      <div v-if="fileList.length < 8">
        <a-icon type="plus" />
        <div class="ant-upload-text">
          <!-- Upload -->
        </div>
      </div>
    </a-upload>
    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
      <img v-if="type==='image'" alt="example" style="width: 100%" :src="previewImage" />
      <video
        v-if="type==='video'"
        width="100%"
        height="600px;"
        controls="controls"
        id="video"
        :src="previewImage">
        您的浏览器不支持播放该视频！
      </video>
    </a-modal>
  </div>
</template>

<script>
import storage from 'store'
import { ACCESS_TOKEN } from '@/store/mutation-types'

function getBase64 (file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  })
}
export default {
  name: 'UploadFileListCmp',
  props: {
    imgUrl: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'image'
    },
    count: {
      type: Number,
      default: 1
    },
    filename: {
      type: String,
      default: ''
    },
    skType: {
      // 实勘类型1视频 2本铺 3内部 4平面 5周边
      type: String,
      default: ''
    },
    fList: {
      type: Array,
      default: () => []
    }
  },
  components: {},
  data () {
    return {
      uploadFlag: true,
      allowMultiple: true,
      loading: false,
      open: false,
      ossUrl: process.env.VUE_APP_OSS_URL,
      uploadImgUrl: process.env.VUE_APP_BASE_URL + '/system/oss/upload',
      headers: {
        Authorization: 'Bearer ' + storage.get(ACCESS_TOKEN),
        Accept: 'application/json, text/plain, */*'
      },
      previewVisible: false,
      previewImage: '',
      fileList: this.fList,
      newFileList: []
    }
  },
  mounted () {},
  created () {
    // console.log(this.fList, this.skType + '===============showFileList')
  },
  watch: {
    previewVisible: function (val) {
      if (!this.previewVisible) {
         const video = document.getElementById('video')
         if (video) {
            video.pause()
         }
      }
    },
    fList: function (val) {
      console.log(val)
      this.fileList = val
    }
  },
  methods: {
    async handlePreview (file) {
      console.log('preview')
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj)
      }
      this.previewImage = file.url || file.preview
      this.previewVisible = true
    },
    handleCancel () {
      this.previewVisible = false
    },
    handleChange ({ file, fileList }) {
       console.log('handleChange', file, fileList)
      if (!this.uploadFlag || file.status === 'error') {
         fileList.pop()
        this.$message.error('上传失败!')
      }
      this.fileList = fileList
      const fileList_ = []
      let fileObj = {}
      for (const f of fileList) {
        if (f && typeof f.name !== 'undefined') {
          fileObj = f
          if (typeof f.response !== 'undefined' && f.response.data && f.response.data.fileName) {
              fileObj = {}
              const fData = f.response.data
              fileObj.name = fData.fileName
              fileObj.status = 'done'
              fileObj.response = { 'code': 200, 'data': { 'ossId': fData.ossId }, 'msg': '操作成功' }
              fileObj.uid = fData.ossId
              fileObj.url = process.env.VUE_APP_OSS_URL + fData.fileName
          }
          fileList_.push(fileObj)
        } else if (f && typeof f.response !== 'undefined') {
          const fData = f.response.data
          fileObj.name = fData.fileName
          fileObj.status = 'done'
          fileObj.uid = fData.ossId
          fileObj.url = process.env.VUE_APP_OSS_URL + fData.fileName
          fileList_.push(fileObj)
        }
      }

      this.newFileList = fileList_
      console.log('fileList_', this.newFileList, this.skType)
      this.$emit('fileListUrlFn', this.newFileList, this.skType)
    },
    beforeUpload (file) {
      // console.log(file, '=====file')
      const accessType = this.type
      const fileType = file.type

     if (fileType.indexOf(accessType) > -1) {
        if (accessType === 'video') { // 视频
          // 文件类型(file.type)、大小限制(file.size)
          const isLt150M = file.size / 1024 / 1024 < 150
          if (!isLt150M) {
            console.log(this.fileList)
            this.$message.error('视频文件超出限制150M，请重新上传!!')
          }
           this.uploadFlag = isLt150M
        }
     } else {
       this.$message.error('文件类型不匹配!')
       this.uploadFlag = false
     }
     return this.uploadFlag
    }
  }
}
</script>
<style lang="less" scoped>
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
</style>
